import { Component, ViewChild } from '@angular/core';
import * as $ from 'jquery';

import { Relatorio, SessionService, Usuario } from '../../session.service';
import { AppLoginModalComponent } from '../app-login/app-login.component'

import { Router } from '@angular/router';

@Component({
    selector: 'app-header-root',
    templateUrl: './app-header.component.html',
    styleUrls: ['./app-header.component.css'],
})

export class AppHeaderComponent {
    @ViewChild("login") login: AppLoginModalComponent;
    menu_reduzido: boolean = false;
    usuario_logado: Usuario = null;
    lstRelatorios: Relatorio[] = [];
    nrRelatorios: number = 0;

    constructor(
        private sessionService: SessionService,
        private router: Router
    ) {
        // Carrega sessão
        this.sessionService.fnGetSessao();
        this.usuario_logado = this.sessionService.usuario;
        this.lstRelatorios = this.sessionService.usuario.lstRelatorios;
        this.nrRelatorios = this.usuario_logado.nrRelatorios;


        this.sessionService.sessao.subscribe((sessao: Usuario) => {
            this.usuario_logado = sessao;
            this.lstRelatorios = sessao.lstRelatorios || [];
            this.nrRelatorios = sessao.nrRelatorios || 0;
        });

        $(window).scroll(() => {
            if ($(window).scrollTop() > 173) {
                this.menu_reduzido = true;
            } else {
                this.menu_reduzido = false;
                
            };   	
        });
    }

    fnLogin() {
        this.login.fnShow('header', 0);
    }
    
    fnPassParameter(idRelatorio: string, dsRelatorio: string){
        this.router.navigate(['/solicitacoes-especiais', idRelatorio, dsRelatorio]);
    }

    get relatoriosValidos(): Relatorio[] {
        return this.lstRelatorios.filter(r => r && r.idRelatorioPB && r.dsRelatorio);
    }
}
